import React from "react";
import { Grid } from "@material-ui/core";
import CustomizedSteppers from "../stepper/StepperIngresoTitular";
import CustomizedSteppersFamiliar from "../stepper/StepperIngresoFamiliar";

export const HomeIngresoTitular = ({ fromBandeja, fromBandejaFamiliar }) => {

  return (
    <Grid container direction="row" alignItems="center">
      {fromBandejaFamiliar
        ?
        <CustomizedSteppersFamiliar />
        :
        <CustomizedSteppers fromBandeja={fromBandeja} />
      }
    </Grid>
  );
};
